import { apiClient } from "../services/authService";

export interface LbpSettings {
  rate: number;
  showLbp: boolean;
}

export const DEFAULT_LBP_SETTINGS: LbpSettings = { rate: 89000, showLbp: false };

const STORAGE_KEY = "lbp_rate_config";

export async function getLbpSettings(): Promise<LbpSettings> {
  try {
    const res = await apiClient.get<{ value: LbpSettings }>("/settings/lbp-rate");
    if (res.data?.value) return res.data.value;
  } catch {}
  const local = localStorage.getItem(STORAGE_KEY);
  if (local) {
    try { return JSON.parse(local); } catch {}
  }
  return DEFAULT_LBP_SETTINGS;
}

export function formatLbpOnly(usdAmount: number, settings: LbpSettings): string {
  const lbp = Math.round(usdAmount * settings.rate).toLocaleString("en-US");
  return `(~${lbp} LBP)`;
}

export function formatDualPrice(usdAmount: number, settings: LbpSettings): string {
  if (!settings.showLbp || !settings.rate) return `$${usdAmount}`;
  return `$${usdAmount} ${formatLbpOnly(usdAmount, settings)}`;
}
